import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _AssignFacilitiesRequestDtoSchema = z.object({
  managerId: z.number(),
  facilityIds: z.array(z.number()),
});

const AssignFacilitiesResponseDtoSchema = z.void();

export type AssignFacilitiesRequestDto = z.infer<
  typeof _AssignFacilitiesRequestDtoSchema
>;
export type AssignFacilitiesResponseDto = z.infer<
  typeof AssignFacilitiesResponseDtoSchema
>;

export const assignFacilities = (
  params: AssignFacilitiesRequestDto,
  config?: AxiosRequestConfig<{ facilityIds: number[] }>
) => {
  const { managerId, facilityIds } = params;

  return api
    .post(`/managers/${managerId}/facilities`, { facilityIds }, config)
    .then(responseContract(AssignFacilitiesResponseDtoSchema));
};
